import React from "react";
import {Box, Divider, IconButton} from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import ListItemReversedTextView from "../../../../../common/components/ListItemReversedTextView";
import parseBoldText from "../../../../../common/utils/AsteriskTextHandler";

export interface ContextSentenceViewProps {
    sentence?: string;
    translation?: string;
    audio: HTMLAudioElement | null;
    showPlaybackButton: boolean;
    onPlayAudio: (audio: HTMLAudioElement | null) => void;
}

export default function ContextSentenceView({sentence, translation, audio, showPlaybackButton, onPlayAudio}: ContextSentenceViewProps) {

    if (!sentence) {
        return null;
    }

    return (
        <ListItemReversedTextView title={`Context Sentence`}
                                  content={(
                                      <Box sx={{display: "flex", alignItems: "start", justifyContent: "flex-start"}}>
                                          {showPlaybackButton && (
                                              <IconButton size="small"
                                                          edge={"start"}
                                                          onClick={() => onPlayAudio(audio)}
                                              >
                                                  <VolumeUpIcon fontSize={"small"} sx={{color: audio ? "black" : "gray"}}/>
                                              </IconButton>
                                          )}
                                          <Box>
                                              {parseBoldText(sentence)}
                                              <Divider/>
                                              {translation}
                                          </Box>
                                      </Box>
                                  )}/>
    );
}
